module.exports = __webpack_public_path__ + "static/img/ta-3.54522e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/mobile/assets/images/partners/taboola/ta-3.png
// module id = Ht2P
// module chunks = 46